import { combineReducers } from "redux";
import cartReducer from "./cartReducer";
import clientReducer from "./clientReducer";
import addressReducer from "./addressReducer";
import authReducer from "./authReducer";
import shippingQuotesReducer from "./shippingQuotesReducer";
import paymentReducer from "./paymentReducer";
import orderReducer from "./orderReducer";
import upsellsReducer from "./upsellsReducer";
import appReducer from "./appReducer";
import postUpsellReducer from "./postUpsellReducer";

const rootReducer = combineReducers({
    // Alphabetical list.
    // Properties should match GlobalState interface.
    addresses: addressReducer,
    app: appReducer,
    auth: authReducer,
    cart: cartReducer,
    client: clientReducer,
    order: orderReducer,
    payment: paymentReducer,
    postUpsell: postUpsellReducer,
    shippingQuotes: shippingQuotesReducer,
    upsells: upsellsReducer,
});

export default rootReducer;
